<template>
  <div id="alterations">
    <div class="header flex-between">
      <div class="header-text">
        <h1>月度同比会员销售数据分析</h1>
      </div>
      <div class="header-button">
        <el-button
            v-if="jurisdiction.search"
            icon="iconfont icon-sousuo1"
            @click="search()"
        >查询</el-button
        >
        <el-button v-if="jurisdiction.search" @click="eliminate"
        >清除查询条件</el-button
        >
        <el-button v-if="jurisdiction.export" @click="exportShow = true"
        >导出</el-button
        >
        <el-button
            v-if="jurisdiction.export"
            @click="(downloadShow = true), getDownladList()"
        >下载</el-button
        >
      </div>
    </div>
    <!-- 首页查询card -->
    <el-card shadow="never">
      <div class="searchform">
        <el-form label-width="140px" :model="queryInfo" size="small">
          <el-row>
            <el-col :span="7">
              <el-form-item label="维护门店">
                <el-input
                    class="inputtt"
                    style="width: 60%"
                    readonly
                    v-model="queryInfo.serviceShopIdstext"
                ></el-input>
                <el-button
                    style="margin-left: 5px"
                    @click="
                    (outletVisible = true),
                      (flag = 1),
                      (shopId = queryInfo.serviceShopIds)
                  "
                >选择门店</el-button
                >
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item label="销售门店">
                <el-input
                    readonly
                    class="inputtt"
                    v-model="queryInfo.saleShopIdstext"
                    type="text"
                    style="width: 60%"
                ></el-input>
                <el-button
                    style="margin-left: 5px"
                    @click="
                    (outletVisible = true),
                      (flag = 2),
                      (shopId = queryInfo.saleShopIds)
                  "
                >
                  选择门店</el-button
                >
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item label="销售日期">
                <el-date-picker
                    style="width: 80%"
                    v-model="dateValue"
                    type="daterange"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :picker-options="pickerOptions"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="7">
              <el-form-item label="会员等级">
                <el-select
                    style="width: 80%"
                    multiple
                    v-model="queryInfo.LevelID"
                >
                  <el-option
                      v-for="item in checkbooksData"
                      :key="item.levelID"
                      :value="item.levelID"
                      :label="item.levelName_cn"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="7">
              <el-form-item label="最后等级">
                <el-select
                    style="width: 80%"
                    multiple
                    v-model="queryInfo.LastLevelID"
                >
                  <el-option
                      v-for="item in checkbooksData"
                      :key="item.levelID"
                      :value="item.levelID"
                      :label="item.levelName_cn"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-card>

    <el-card shadow="never" class="centercard">
      <el-table
          :key="key"
          size="small"
          class="table-style"
          :height="isMore ? 'calc(100vh - 22.5rem)' : 'calc(100vh - 20rem)'"
          border
          :row-class-name="tableRowClassName"
          :header-cell-style="{
            background: '#FCFBF2',
            color: '#6C6839',
            'text-align': 'center',
            fontSize: '14px',
          }"
          :cell-style="{ 'text-align': 'center' }"
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          v-el-table-infinite-scroll="load"
          v-loading="loading"
          infinite-scroll-disabled="onLoading"
      >
        <el-table-column type="index" label="No."></el-table-column>
        <el-table-column prop="regionName" label="销售区域" min-width="100"> </el-table-column>
        <el-table-column prop="shopCode" label="销售门店编号" min-width="120"> </el-table-column>
        <el-table-column prop="cardNo" label="卡号" min-width="90"> </el-table-column>
        <el-table-column prop="origLvlLevelName" label="消费前最初等级" min-width="140"> </el-table-column>
        <el-table-column prop="lastLvlLevelName" label="最后的等级" min-width="90"> </el-table-column>
        <el-table-column prop="amount" label="消费总额" min-width="90">
          <template slot-scope="scope">
            {{ toThousands(scope.row.amount) }}
          </template>
        </el-table-column>
        <el-table-column prop="coupAmt" label="使用礼券金额" min-width="140"> </el-table-column>
        <el-table-column prop="saleTimes" label="消费单数" min-width="90"> </el-table-column>
        <el-table-column prop="itemQty" label="消费件数" min-width="90"> </el-table-column>
        <el-table-column prop="avgDiscount" label="整体折扣率" min-width="130">
          <template slot-scope="scope">
            {{ scope.row.avgDiscount }} %
          </template></el-table-column>
      </el-table>

      <el-alert
          v-if="isMore"
          title="没有更多啦!"
          type="warning"
          center
          :closable="false"
      ></el-alert>
    </el-card>
    <!-- 筛选条件弹窗 -->

    <!-- 选择门店 -->
    <div class="outlet">
      <el-dialog
          :close-on-click-modal="false"
          width="35%"
          :visible.sync="outletVisible"
          title="选择门店"
          class="store-modal"
      >
        <el-form size="mini" label-width="90px">
          <el-row v-for="(item, index) in StoreSelectionList" :key="index">
            <el-col :span="12" v-for="(myitem, myindex) in item" :key="myindex">
              <el-tree
                  ref="tree"
                  v-if="myitem != undefined"
                  :data="[myitem]"
                  show-checkbox
                  node-key="shopID"
                  highlight-current
                  default-expand-all
                  :default-checked-keys="shopId"
                  :props="defaultProps"
              >
              </el-tree>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="ComButtomStore">确 定</el-button>
          <el-button @click="outletVisible = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 选择显示列弹窗 -->

    <!-- 导出弹窗 -->
    <div class="exporttc">
      <el-dialog
          :close-on-click-modal="false"
          width="20%"
          title="导出月度同比会员销售数据分析"
          :visible.sync="exportShow"
      >
        <div style="height: 50px; font-size: 14px; font-weight: 700">
          <p>
            <i
                class="iconfont icon-jingshi"
                style="font-size: 28px; color: #f39b21"
            ></i>
            是否确定
            <span style="color: #ff0000">导出</span>月度同比会员销售数据分析报表?
          </p>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="Export">确 定</el-button>
          <el-button @click="exportShow = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 下载弹窗 -->
    <el-dialog
        append-to-body
        width="50%"
        :visible.sync="downloadShow"
        title="下载文件"
    >
      <el-table
          size="small"
          class="table-style"
          border
          :row-class-name="tableRowClassName"
          :header-cell-style="{
          background: '#FCFBF2',
          'text-align': 'center',
          color: '#6C6839',
          fontSize: '14px',
        }"
          :cell-style="{ 'text-align': 'center' }"
          ref="multipleTable"
          :data="downloadData"
          tooltip-effect="dark"
          style="width: 100%"
      >
        <el-table-column type="index" width="55"></el-table-column>
        <el-table-column
            prop="startTime"
            label="开始执行时间"
        ></el-table-column>

        <el-table-column prop="endTime" label="结束执行时间"></el-table-column>

        <el-table-column prop="fileName" label="文件名"></el-table-column>

        <el-table-column prop="isComplate" label="状态">
          <template slot-scope="scope">
            {{ scope.row.isComplate ? "完成" : "执行中" }}
          </template>
        </el-table-column>
        <el-table-column prop="startTime" label="下载">
          <template slot-scope="scope">
            <el-button
                icon="el-icon-download"
                v-if="scope.row.isComplate"
                @click="download(scope.row.downloadUrl)"
            >下载</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import {
  RegionApi,
  monthlyCustSalesDataAnalysisApi, reportMonthlyCustSalesDataAnalysisApi, reportFormList,
} from "@/api/reportForm";
 import {queryLSelectApi} from "@/api/user"; // 会员等级接口
import { getcpyNo } from "@/utils/auth";
export default {
  name: "MonthlyCustSalesDataAnalysis",
  data() {
    return {
      jurisdiction: {
        search: false,
        export: false,
      },
      downloadData: [],
      downloadShow: false,
      exportShow: false,

      //
      formThead: [],
      key: "",
      ID1: "",
      Selectdisplayitem: [],
      Selectdisplayiteme: [],

      // 首页radio
      radio: "",
      // 首页radio选中获取数据
      radioValuesjList: [],
      // 首页列表内容
      tableData: [],
      // 首页loading
      loading: false,

      bodyStyle: {
        padding: "0px",
      },
      dateValue: [new Date().getTime() - 3600 * 1000 * 24 * 365, new Date()], // 注册日期
      queryInfo: {
        pageNum: 1,
        pageSize: 20,
        pages: 0,
        displayFiled: [],
        levelID: "", // 会员等级
        serviceShopIdstext: "", // 维护店id文字
        serviceShopIds: [], // 维护店id
        saleDateStart: "", // 起
        saleDateEnd: "", // 止
        saleShopIdstext: "", // 销售店id文字
        saleShopIds: [], // 销售店id
        regionIds: [], // 维护区域
        LevelID: [], // 等级
        LastLevelID: [], // 最后等级

      },

      checkbooksData: [], //会员等级
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一年",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      outletVisible: false,
      // 选择门店数据
      shopId: [],
      StoreSelectionList: [],
      StoredataArray: [],
      StoreSelectLength: 0,
      defaultProps: {
        children: "chlidren",
        label: "lable",
      },
      flag: 0,
      // checkbooksData: [], //会员等级
      ServiceOrgName: "", //维护店
      months: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      days: [
        1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
        21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31,
      ],
      levelRmfList: [],

    };
  },
  watch: {
    outletVisible(val) {
      if (val) {
        this.ShopqueryRegionList({ state: 1 });
      }
    },
  },
  created() {
    // this.ShopqueryRegionList({ state: 1 });
    this.search();

    queryLSelectApi({ cpyNO: getcpyNo() }).then((res) => {
      this.checkbooksData = res.data;
    });
    let MonthlyCustSalesDataAnalysis = JSON.parse(
        localStorage.getItem("MonthlyCustSalesDataAnalysis")
    );
    for (let i = 0; i < MonthlyCustSalesDataAnalysis.length; i++) {
      if (MonthlyCustSalesDataAnalysis[i].menuName == "查询") {
        this.jurisdiction.search = true;
        continue;
      }
      if (MonthlyCustSalesDataAnalysis[i].menuName == "导出") {
        this.jurisdiction.export = true;
        continue;
      }
    }
  },
  computed: {
    isMore() {
      return this.queryInfo.pageNum >= this.queryInfo.pages;
    },
    onLoading() {
      return this.loading || this.isMore;
    },
  },
  methods: {
    //获取下载列表数据
    //获取下载列表数据
    getDownladList() {
      reportFormList({
        groupName: "会员销售分析报表",
      }).then((response) => {
        this.downloadData = response.data;
      });
    },
    download(src) {
      this.exportShow = false;
      const ele = document.createElement("a");
      ele.style.display = "none";
      ele.href = src;
      ele.download = "";
      document.querySelectorAll("body")[0].appendChild(ele);
      ele.click();
      ele.remove();
    },

    //参数处理
    processingParams() {
      // 销售日期
      if (this.dateValue && this.dateValue.length > 0) {
        this.queryInfo.saleDateStart = this.renderTime(
            this.dateValue[0]
        ).substring(0, 10);
        this.queryInfo.saleDateEnd = this.renderTime(
            this.dateValue[1]
        ).substring(0, 10);
      } else {
        this.queryInfo.saleDateStart = undefined;
        this.queryInfo.saleDateEnd = undefined;
      }
      let data = {
        pageNum: this.queryInfo.pageNum,
        pageSize: this.queryInfo.pageSize,
        pages: this.queryInfo.pages,
        serviceShopIds:
        this.queryInfo.serviceShopIds== undefined || this.queryInfo.serviceShopIds.length == 0
                ? undefined
                : this.queryInfo.serviceShopIds,
        saleShopIds:
            this.queryInfo.saleShopIds== undefined || this.queryInfo.saleShopIds.length == 0
                ? undefined
                : this.queryInfo.saleShopIds,
        saleDateStart: this.queryInfo.saleDateStart,
        saleDateEnd: this.queryInfo.saleDateEnd,
        LevelIDs:
            this.queryInfo.LevelID.length == 0
                ? undefined
                : this.queryInfo.LevelID,
        lastLvlDs:
            this.queryInfo.LastLevelID.length == 0
                ? undefined
                : this.queryInfo.LastLevelID,
      };
      return data;
    },
    // 导出
    Export() {

      reportMonthlyCustSalesDataAnalysisApi(this.processingParams()).then(() => {
        this.exportShow = false;
        this.$message.success("导出成功请在下载列表查看!");
      });
    },
    // 查询
    async  viewCustomers(){
      await  monthlyCustSalesDataAnalysisApi(this.processingParams()).then((res) => {
        if (res.success !== true) {
          this.$message.error("查询角色失败!");
          return;
        } else {
          if (this.queryInfo.pageNum == 1) this.tableData = [];
          this.tableData = this.tableData.concat(res.data.list);
          this.queryInfo.pages = res.data.pages;
          this.loading = false;
        }
      });
    },


    // 查询
    search() {
      this.queryInfo.pageNum = 1;
      this.viewCustomers();
    },
    // 清除查询筛选条件
    eliminate() {
      this.queryInfo = {
        pageNum: 1,
        pageSize: 20,
        pages: 0,
        displayFiled: this.queryInfo.displayFiled,

        levelID: "", // 会员等级
        serviceShopIdstext: "", // 维护店id文字
        serviceShopIds: [], // 维护店id文字
        saleDateStart: "", // 起
        saleDateEnd: "", // 止

        saleShopIdstext: "", // 销售店id文字
        saleShopIds: [], // 销售店id
        LevelID: [], // 等级
        LastLevelID: [], // 最后等级

      };
      this.dateValue =[new Date().getTime() - 3600 * 1000 * 24 * 365, new Date()];
      this.protectionDate = []; //保级日期
      this.dateValue1 = []; //创建日期

      this.ServiceOrgName = ""; //维护店
      this.FirstVipOrgName = ""; //升级为VIC的机构
      this.tableData = [];
      this.viewCustomers();
      this.$message.success("清除查询条件成功!");
    },
    load() {
      this.loading = true;
      setTimeout(() => {
        this.queryInfo.pageNum += 1;
        this.viewCustomers();
      }, 1000);
    },
    ShopqueryRegionList(params) {
      RegionApi(params).then((res) => {
        let arr1 = [],
            arr2 = [];
        if (res.success) {
          this.StoredataArray = [];
          this.StoreSelectLength = 0;
          res.data.forEach((item) => {
            if (item.chlidren.length > 0) this.StoredataArray.push(item);
          });
          this.StoredataArray.forEach((item, index) => {
            item.chlidren.forEach((item) => {
              item.shopID = item.id;
            });
            this.StoreSelectLength += 1;
            if (index % 2 == 0) {
              arr1.push(item);
            } else {
              arr2.push(item);
            }
          });
          this.StoreSelectionList = arr1.map((key, value) => [
            key,
            arr2[value],
          ]);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    ComButtomStore() {
      // 获取已选择的门店数据
      let listOfSomeStoresl = [];
      let listOfSomeStoreslStr = "";
      for (let index = 0; index < this.StoreSelectLength; index++) {
        let item = this.$refs.tree[index].getCheckedNodes();
        if (item.length == this.StoredataArray[index].chlidren.length + 1) {
          listOfSomeStoresl.push(...this.StoredataArray[index].chlidren);
        } else {
          listOfSomeStoresl.push(...item);
        }
      }
      if (this.flag === 1 || this.flag === 2) {
        listOfSomeStoresl.forEach((item) => {
          listOfSomeStoreslStr += item.lable + ",";
        });
        listOfSomeStoreslStr = listOfSomeStoreslStr.substring(
            0,
            listOfSomeStoreslStr.length - 1
        );
        console.log("1", this.flag);
      } else {
        listOfSomeStoresl.forEach((item) => {
          listOfSomeStoreslStr += `${item.lable}\n`;
        });
        console.log("2", this.flag);
      }
      let shopId = []; //选中门店数据
      for (let i = 0; i < listOfSomeStoresl.length; i++) {
        shopId.push(listOfSomeStoresl[i].id);
      }
      if (this.flag == 1) {
        this.queryInfo.serviceShopIdstext = listOfSomeStoreslStr;
        this.queryInfo.serviceShopIds = shopId;
      } else if (this.flag == 2) {
        this.queryInfo.saleShopIdstext = listOfSomeStoreslStr;
        this.queryInfo.saleShopIds = shopId;
      } else if (this.flag == 3) {
        this.ServiceOrgName = listOfSomeStoreslStr;
        this.queryInfo.shopIds = shopId;
      }
      this.outletVisible = false;
    },
    // 数字千分位格式化
    toThousands(num) {
      if (num) {
        num = num + "";
        return num.replace(/\d+/, function (n) {
          return n.replace(/(\d)(?=(?:\d{3})+$)/g, "$1,");
        });
      } else return 0;
    },
    // 判断如果是单行就变黄色双行是白色
    tableRowClassName({ rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "warning-row";
      }
      return "";
    },

    renderTime(date) {
      //格式化时间
      if (date != null) {
        var dateee = new Date(date).toJSON();
        return new Date(+new Date(dateee) + 8 * 3600 * 1000)
            .toISOString()
            .replace(/T/g, " ")
            .replace(/\.[\d]{3}Z/, "");
      } else {
        return "";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  // 改变table里的按钮图标大小
  .table-button .iconfont {
    font-size: 14px;
  }
  .el-table .warning-row {
    background: #fcfbf2;
  }

  .el-table .success-row {
    background: #ffffff;
  }
}
.dialogTitle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 50px;
}
.dialogTitle > span {
  font-size: 16px;
  font-weight: 700;
  color: #6c6937;
}
/deep/.el-dialog__header {
  padding: 1.25rem 1.25rem 0.625rem;
  background-color: #d1cda5;
}
.dialog-footer {
  height: 40px;
  display: flex;
  justify-content: space-around;
}
/deep/.el-dialog__footer {
  height: 60px;
  text-align: center;
  background-color: #f2f2f2;
}
/deep/.inputtt .el-input__inner {
  overflow: hidden;
  /* white-space: nowrap; */
  text-overflow: ellipsis;
}
#alterations {
  height: 100%;
}
.header-text {
  height: 50px;
  margin-top: 20px;
  color: #76734f;
}
.searchform {
  margin-top: 20px;
}
.centercard {
  margin-top: 10px;
}
.card-pagination {
  margin-top: 20px;
  text-align: right;
}
// 按钮边框去掉，文字颜色和加粗
/deep/ button {
  border-color: #e6e0af;
  border-radius: 7px;
  color: #a19b59;
}
/deep/input {
  border-radius: 0 !important;
}
// 去除表头复选框
/deep/ .table-style {
  .el-table-column--selection.is-leaf .el-checkbox {
    display: none;
  }
}
</style>
